import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import BasicTable from '../Components/Global_Components/reacttable/table';
import '../styles/Patients.scss';

import {Tooltip as ReactTooltip} from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import Swal from 'sweetalert2';
import {setDoctorsDetailsList, sidebar} from '../Redux/Slice/rootSlice';
import {deleteUserDetails, fetchUsersList, getDoctorsList, getUserDetails, postCreateUser, updateUserDetails} from '../Redux/Thunk/Actions';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import {debounce} from 'lodash';
dayjs.extend(localizedFormat);

function CreateUser({
  loaderchange,
  //   enableditview,
  popupalert,
  popuptext
}) {
  const [tableheaderdata, settableheaderdata] = useState([]);
  const userdata = useSelector(state => state.counter.userdata);
  const [datacount, setdatacount] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [searchDate, setSearchDate] = useState('');
  const [update, setUpdate] = useState('');
  const viewpatient = useNavigate();
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const createpageReport = useSelector(state => state.counter.patientReportCreateredux);
  const [branches, setbranches] = useState('0');
  const [todaysTotal, setTodaysTotal] = useState(0);
  const [initialBillDate, setInitialBillDate] = useState('');
  const [alert, setalert] = useState(false);
  const edituser = useSelector(state => state.counter.edituser);
  const adminuser = useNavigate();
  const [changeAlert, setChangeAlert] = useState(false);
  // const [roledata, setroledata] = useState("");
  const roledata = 'Super Admin';
  const [closeCreatePopup, setCloseCreatePopup] = useState(false);
  const [closeEditPopup, setCloseEditPopup] = useState(false);
  const [error, seterror] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setsearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateQuery, setDateQuery] = useState(dayjs().format('YYYY-MM-DD'));

  const [startDate, setStartDate] = useState();
  const dateStr = '2024-01-23T10:45:42.716334Z';
  const formattedDate = dayjs(dateStr).format('YYYY-MM-DD');
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));

  const [wawlwsjkf, setwawlwsjkf] = useState(true);
  const [MsgPopUp, setMsgPopUp] = useState(false);

  const [deleteId, setDeleteId] = useState('');
  const [remarkMsg, setRemarkMsg] = useState('');
  const [tableArchive, setTableArchive] = useState(false);
  const [remarkError, setRemarkError] = useState(false);
  const [createUserPopUp, setCreateUserPopUp] = useState(false);

  const [patientReportCreate, setPatientReportCreate] = useState(createpageReport);
  const [isEditUser, setIsEditUser] = useState(false);
  const [appointName, setAppointName] = useState('');
  const [editUserID, setEditUserId] = useState('');
  const [trigger, setTrigger] = useState(false);
  const [pwdVisible, setPwdVisible] = useState(false);
  const [cnfPwdVisible, setCnfPwdVisible] = useState(false);
  const [pwdError, setPwdError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [doctorsDetails, setDoctorsDetails] = useState('');
  const doctorsDetailsList = useSelector(state => state.counter.doctorsDetailsList);
  const [userData, setUserData] = useState({
    user_name: '',
    first_name: '',
    last_name: '',
    password: '',
    cnfPassword: '',
    role: 'Select',
    email: ''
  });
  const todayDate = dayjs().format('YYYY/MM/DD').replace(/\//g, '-');

  const deleteUser = async e => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async result => {
      if (result.isConfirmed) {
        await dispatch(deleteUserDetails(e));
        setTrigger(!trigger);
        Swal.fire({
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          icon: 'success'
        });
      }
    });
  };
  const editUserDetails = async e => {
    setCreateUserPopUp(true);
    setIsEditUser(true);
    const userDetails = getUserDetails(e);
    const response = await dispatch(userDetails);
    // console.log(response, "userDetails");
    // let data = response.payload.data.patient_id;
    // let name = data?.titles + " " + data?.first_name + " " + data?.last_name;
    setUserData({
      user_name: response.payload.data.user_name,
      first_name: response.payload.data.first_name,
      last_name: response.payload.data.last_name,
      email: response.payload.data.email,
      role: response.payload.data.role
    });
    setEditUserId(response.payload.data.id);
  };

  const handlesetUserData = e => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value
    });
    setErrorText('');
  };

  const createNewUser = async () => {
    if (userData.password === userData.cnfPassword) {
      loaderchange('true');
      setPwdError(false);
      let data = {
        user_name: userData.user_name,
        first_name: userData.first_name,
        last_name: userData.last_name,
        password: userData.password,
        role: userData.role,
        email: userData.email
      };
      let response = await dispatch(postCreateUser(data));
      console.log(response, 'resssss');
      if (response.payload === 'Request failed with status code 502') {
        setPwdError(true);
        setErrorText('ⓘ Email Already Exists');
      } else if (response?.payload?.status?.code === 200) {
        setCreateUserPopUp(false);
        popupalert('true');
        popuptext('Created Successfully');
      }
      loaderchange('false');
    } else {
      setPwdError(true);
      setErrorText('ⓘ Password Do Not Match');
    }
    // setCreateUserPopUp(false);
    // await dispatch(postAppointment(userData));
    // setTrigger(!trigger);
  };
  const saveEditUser = async () => {
    // console.log(userData, "isEditUser");
    loaderchange('true');
    setCreateUserPopUp(false);
    console.log(userData, 'userDataiiii');
    if (userData?.cnfPassword?.length >= 1) {
      let editedData = {
        user_name: userData.user_name,
        first_name: userData.first_name,
        last_name: userData.last_name,
        password: userData.cnfPassword,
        role: userData.role,
        email: userData.email
      };
      let data = {
        userData: editedData,
        editUserID: editUserID
      };
      await dispatch(updateUserDetails(data));
      setTrigger(!trigger);
      loaderchange('false');
    } else if (userData?.cnfPassword === '' || userData?.cnfPassword === undefined) {
      let editedData = {
        user_name: userData.user_name,
        first_name: userData.first_name,
        last_name: userData.last_name,
        role: userData.role,
        email: userData.email
      };
      let data = {
        userData: editedData,
        editUserID: editUserID
      };
      await dispatch(updateUserDetails(data));
      setTrigger(!trigger);
      loaderchange('false');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const dataPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        search: searchQuery,
        // date: dateQuery,
        range: true
      };
      loaderchange('true');
      const usersLists = fetchUsersList(dataPayload);
      const responseUsersDetails = await dispatch(usersLists);
      console.log(responseUsersDetails);

      debounce(async () => {
        const doctorsList = await dispatch(getDoctorsList());
        let docDetails = doctorsList.payload.data;
        dispatch(setDoctorsDetailsList(docDetails));
      }, 600)();
      if (responseUsersDetails?.payload?.status?.code === 200) {
        settableheaderdata(responseUsersDetails.payload.data);
        setdatacount(responseUsersDetails.payload.total_count);
        loaderchange('false');

        //     setTodaysTotal(responseUsersDetails.payload.data.total_bill_price);
        //     if (!setwawlwsjkf) {
        //       setTodaysTotal(responseUsersDetails.payload.data.total_bill_price);
        //     }
        //     setInitialBillDate(
        //       dayjs(responseUsersDetails.payload.data.first_date).format(
        //         "YYYY-MM-DD"
        //       )
        //     );
        //     loaderchange("false");
        //     setwawlwsjkf(false);
        //   } else {
        //     loaderchange("false");
        //     popupalert("true");
        //     popuptext("No Data Available");
        //     setTimeout(() => {
        //       popupalert("false");
        //     }, 2000);
      }
    };

    fetchData();
  }, [dtpageindex, dtpagesize, search, searchQuery, branches, update, startDate, deleteId, endDate, tableArchive, todaysTotal, createUserPopUp, trigger, dateQuery]);

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={row.row.original.first_name + ' ' + row.row.original.last_name}>
                  {row.row.original.first_name + ' ' + row.row.original.last_name}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Role',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.role)}>
                  {row.row.original.role}
                </div>
              </span>
            </>
          );
        }
      },

      //   {
      //     Header: "Doctor",
      //     accessor: "",
      //     Cell: (row) => {
      //       let doctorName
      //       doctorsDetailsList.forEach(ele => {
      //         if (ele.id===row.row.original.doctor_id) {
      //           doctorName=ele.user_name
      //         }
      //       })

      //       return (
      //         <>
      //           <span>
      //             <div
      //               style={{ marginTop: "3px" }}
      //               data-tooltip-id="my-tooltip"
      //               data-tooltip-content={String(
      //                 "docName"
      //               )}
      //             >
      //               {doctorName}
      //               {/* doc */}
      //             </div>
      //           </span>
      //         </>
      //       );
      //     },
      //   },
      {
        Header: 'Email',
        accessor: '',
        Cell: row => {
          // const final_value = row.row.original.created_at.slice(0, 10);
          // const [year, month, day] = final_value.split("-");
          // const formattedDate = `${day}-${month}-${year}`;
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={row.row.original.email}>
                  {row.row.original.email}
                </div>
              </span>
            </>
          );
        }
      },
      //   {
      //     Header: "Time",
      //     accessor: "",
      //     Cell: (row) => {
      //       // const inputDateTime = "2023-11-08T07:35:00.730468Z";
      //       // const date = new Date(inputDateTime);
      //       // const hours = date.getHours();
      //       // const minutes = date.getMinutes();
      //       // const formattedHours = hours.toString().padStart(2, "0");
      //       // const formattedMinutes = minutes.toString().padStart(2, "0");
      //       // const time = `${formattedHours}:${formattedMinutes}`;
      //       // const date = new Date(row.row.original.created_at);
      //       // const hours = date.getHours();
      //       // const minutes = date.getMinutes();
      //       // const amOrPm = hours >= 12 ? "PM" : "AM";
      //       // let formattedHours = (hours % 12).toString().padStart(2, "0");
      //       // formattedHours = formattedHours === "00" ? "12" : formattedHours;
      //       // const formattedMinutes = minutes.toString().padStart(2, "0");
      //       // const time = `${formattedHours}:${formattedMinutes} ${amOrPm}`;
      //       const time = row.row.original.time.split(":");
      //       const formatTime = `${Math.abs(
      //         time[0] <= 12 && time[0] != "00" ? time[0] : time[0] - 12
      //       )}:${time[1]} ${time[0] - 12 < 0 ? "AM" : "PM"}`;
      //       return (
      //         <>
      //           <span>
      //             <div
      //               style={{ marginTop: "3px" }}
      //               data-tooltip-id="my-tooltip"
      //               data-tooltip-content={formatTime}
      //             >
      //               {formatTime}
      //             </div>
      //           </span>
      //         </>
      //       );
      //     },
      //   },
      //   {
      //     Header: "Status",
      //     accessor: "",
      //     Cell: (row) => {
      //       // console.log(row.row.original.username)
      //       return (
      //         <>
      //           <span>
      //             <div
      //               style={{ marginTop: "3px" }}
      //               data-tooltip-id="my-tooltip"
      //               data-tooltip-content={String(row.row.original.status)}
      //             >
      //               {row.row.original.status}
      //             </div>
      //           </span>
      //         </>
      //       );
      //     },
      //   },
      //   {
      //     Header: "Mode of Payment",
      //     accessor: "",
      //     Cell: (row) => {
      //       // console.log(row.row.original.username)
      //       const lst = []
      //       console.log(row.row.original);
      //       if(row.row.original["mode_one"]!= null){

      //           lst.push(row.row.original["mode_one"])
      //         }
      //       if(row.row.original["mode_two"]!= null){

      //           lst.push(row.row.original["mode_two"])
      //         }
      //       if(row.row.original["mode_three"]!= null){

      //           lst.push(row.row.original["mode_three"])
      //         }

      //       return (
      //         <>
      //           <span>
      //             {lst.map((e)=>{
      //               return(
      //                 <div data-tooltip-id="my-tooltip"
      //                 data-tooltip-content={String(e)}>{e}</div>
      //               )
      //             })}
      //           </span>
      //         </>
      //       );
      //     },
      //   },
      //   {
      //     Header: "Total Bill",
      //     accessor: "",
      //     Cell: (row) => {
      //       // console.log(row.row.original.username)
      //       return (
      //         <>
      //           {row.row.original.bill_price}
      //           {/* {todaysTotal} */}
      //         </>
      //       );
      //     },
      //   },
      {
        Header: 'Actions',

        accessor: '',
        Cell: row => {
          if (tableArchive) {
            return (
              <div className='style' style={{width: '150px', height: '50px', overflow: 'scroll'}}>
                <div data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.remarks)}>
                  {row.row.original.remarks}
                </div>
              </div>
            );
          } else {
            return (
              <div className='style'>
                <button type='button' class='btn btn-danger btn-sm trash' style={{display: 'flex', gap: '4px'}} onClick={e => deleteUser(row.row.original.id, e)}>
                  <i onClick={e => deleteUser(row.row.original.id, e)} class='bi bi-trash'></i> Delete
                </button>
                <button type='button' class='btn btn-danger btn-sm delete' style={{display: 'flex', gap: '4px'}} onClick={e => editUserDetails(row.row.original.id, e)}>
                  <i onClick={e => editUserDetails(row.row.original.id, e)} class='bi bi-pen'></i> Edit
                </button>
              </div>
            );
          }
        }
      }
    ],
    [createUserPopUp, dateQuery, trigger, searchQuery]
  );

  const createAppointmentFunc = async e => {
    setUserData({
      user_name: '',
      first_name: '',
      last_name: '',
      password: '',
      cnfPassword: '',
      role: 'Select',
      email: ''
    });
    setIsEditUser(false);
    setCreateUserPopUp(true);
  };

  const pagesize = arg => {
    setdtPagesize(arg);
  };

  const pageindex = arg => {
    setdtPageindex(arg);
  };
  const handleSubmit = event => {
    event.preventDefault();
  };

  const patientId = useSelector(state => state.counter.patientid);

  const [value, setValue] = React.useState(dayjs());

  return (
    <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
      <div className='patient-header'>
        <div className='row'>
          <div className='col'>
            <h3 className='page-title'>All Users</h3>
            <ul className='breadcrumb'>
              <li className='breadcrumb-item'>
                <a
                  href='/'
                  style={{textDecoration: 'none', color: 'black'}}
                  onClick={e => {
                    dispatch(sidebar('DashBoard'));
                  }}>
                  Dashboard
                </a>
              </li>
              <li className='breadcrumb-item active'>All Users</li>
            </ul>
          </div>
        </div>

        <div className='add_btn'>
          <button onClick={createAppointmentFunc} className='btn_1'>
            Create User
          </button>
        </div>
      </div>

      <div className='billableCard'>
        <p>
          Users
          {/* {dateQuery === dayjs().format("YYYY-MM-DD")
            ? "Today's Appointment Overview"
            : `${dateQuery} Appointment Overview`} */}
          {/* &nbsp;:&nbsp; */}
          {/* <span>{todaysTotal ?? 0}&nbsp;Rs</span> */}
        </p>
      </div>

      <div className='row' style={{marginTop: 20}}>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='patient'>
                <div className='table-content-patient'>
                  <form onSubmit={handleSubmit} style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div class='input-group rounded' style={{width: '250px', height: '40px'}}>
                      <input
                        type='search'
                        class='form-control rounded'
                        aria-label='Search'
                        aria-describedby='search-addon'
                        value={searchQuery}
                        style={{
                          height: '40px'
                        }}
                        // onChange={e=>{
                        //   if(e.target.value.length === 0){
                        //     setDateQuery(dayjs().format("YYYY-MM-DD"))
                        //   }
                        // }}
                        // onKeyDown={(e) => {
                        //   if (e.target.value.length === 0 && e.which === 32) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        onChange={e => {
                          if (e.target.value.length <= '100') {
                            setSearchQuery(e.target.value);
                            setdtPageindex(1);

                            setDateQuery(e.target.value === '' ? todayDate : '');
                            console.log(todayDate);
                          } else {
                            e.preventDefault();
                          }
                        }}
                        // onKeyDown={(e)=>{if(e.which=="32"){
                        //   e.preventDefault()
                        // }}}

                        min='0'
                        max='10'
                        label='Search'
                        placeholder='Search...'
                        required
                      />

                      <span class='input-group-text border-0 bg-transparent p-0' id='search-addon'>
                        <i
                          class='bi bi-search'
                          style={{
                            color: '#1b5a90',
                            width: '20px',
                            height: '20px',
                            marginLeft: '10px'
                          }}></i>
                      </span>
                    </div>
                    {/* <div >
                      <select className="form-select" onChange={currentableData}>
                        <option value="all">All</option>
                        <option value="archived">Cancelled</option>
                      </select>
                    </div> */}
                    {/* <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <input
                        style={{ width: "200px", height: "40px" }}
                        defaultValue={dateQuery}
                        className="form-control rounded"
                        type="date"
                        onChange={(e) => {
                          setDateQuery(e.target.value);
                          setSearchQuery("");
                        }}
                      />
                    </div> */}
                  </form>

                  <div className='table-patient'>
                    <BasicTable columns={columns} data={tableheaderdata} pagesize={pagesize} pageindex={pageindex} dtpagesize={dtpagesize} dtpageindex={dtpageindex} datacount={datacount} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {createUserPopUp && (
        <div className='CreatePopUp'>
          <div className={isEditUser ? 'hidePasswordContainer appointmentCPContainer' : 'appointmentCPContainer createPopUPContainer'}>
            <section className='appointmentCPBox'>
              <section>
                <h1>{isEditUser ? `Edit User` : `Create User`}</h1>
                <h2
                  onClick={() => {
                    setCreateUserPopUp(false);
                  }}>
                  X
                </h2>
              </section>

              <form>
                <div className='divBox'>
                  <section className='uhidNameContainer'>
                    <div>
                      <label>User Name :</label>
                      <br />
                      <input type='text' onChange={handlesetUserData} autocomplete='off' id='' name='user_name' className='form-control' value={userData.user_name} />
                      {/* <span>hello</span> */}
                    </div>
                    <div>
                      <label>Email :</label>
                      <br />
                      <input
                        type='email'
                        // defaultValue={appointName}
                        autocomplete='off'
                        id=''
                        onChange={handlesetUserData}
                        name='email'
                        className='form-control'
                        value={userData.email}
                      />
                    </div>
                  </section>
                  <section className='uhidNameContainer'>
                    <div>
                      <label>First Name :</label>
                      <br />
                      <input type='text' onChange={handlesetUserData} autocomplete='off' id='' name='first_name' className='form-control' value={userData.first_name} />
                      {/* <span>hello</span> */}
                    </div>
                    <div>
                      <label>Last Name :</label>
                      <br />
                      <input type='text' onChange={handlesetUserData} autocomplete='off' id='' name='last_name' className='form-control' value={userData.last_name} />
                      {/* <span>hello</span> */}
                    </div>
                    {/* <div>
                    <label>Doctor :</label>
                    <br />
                    <select
                      name="doctor_id"
                      onChange={handlesetUserData}
                      value={userData.doctor_id}
                    >
                      <option value="Select" selected disabled>
                        Select
                      </option>
                      
                    </select>
                  </div> */}
                  </section>
                  {/* {true && ( */}
                  {!isEditUser && (
                    <section className='dateStatusContainer'>
                      <div>
                        <label>Password :</label>
                        <br />
                        <div className='eye'>
                          <input
                            onChange={handlesetUserData}
                            autocomplete='off'
                            id=''
                            name='password'
                            type={pwdVisible ? 'text' : 'password'}
                            className='form-control pwdCreate'
                            value={userData.password}
                          />
                          <i className={pwdVisible ? 'fa fa-eye' : 'fa fa-eye-slash'} onClick={() => setPwdVisible(!pwdVisible)} />
                        </div>
                      </div>
                      <div>
                        <label>Confirm Password :</label>
                        <br />
                        <div className='eye'>
                          <input
                            onChange={handlesetUserData}
                            autocomplete='off'
                            id=''
                            name='cnfPassword'
                            type={cnfPwdVisible ? 'text' : 'password'}
                            className='form-control pwdCreate'
                            value={userData.cnfPassword}
                          />
                          <i className={cnfPwdVisible ? 'fa fa-eye' : 'fa fa-eye-slash'} onClick={() => setCnfPwdVisible(!cnfPwdVisible)} />
                        </div>
                      </div>
                    </section>
                  )}
                  {isEditUser && (
                    <section className='dateStatusContainer'>
                      <div>
                        <label>Password :</label>
                        <br />
                        <div className='eye'>
                          <input
                            onChange={handlesetUserData}
                            autocomplete='off'
                            id=''
                            name='cnfPassword'
                            type={pwdVisible ? 'text' : 'password'}
                            className='form-control pwdCreate'
                            value={userData.cnfPassword}
                          />
                          <i className={pwdVisible ? 'fa fa-eye' : 'fa fa-eye-slash'} onClick={() => setPwdVisible(!pwdVisible)} />
                        </div>
                      </div>
                    </section>
                  )}
                  <section className='dateStatusContainer'>
                    {/* <div>
                    <label>Email :</label>
                    <br />
                    <input
                      onChange={handlesetUserData}
                      name="email"
                      type="email"
                      className="form-control"
                      value={userData.date + "T" + userData.time}
                    />
                  </div> */}
                    <div>
                      <label>Role : </label>
                      <br />
                      <select
                        name='role'
                        // onChange={onHandleChange}
                        onChange={handlesetUserData}
                        className='form-control'
                        value={
                          userData.role
                          // isEditUser ? userData.status : "Select"
                        }>
                        <option selected disabled value='Select'>
                          Select
                        </option>
                        <option value='Doctor'>Doctor</option>
                        <option value='Lab' key=''>
                          Lab
                        </option>
                        <option value='Staff' key=''>
                          Staff
                        </option>
                        <option value='Admin' key=''>
                          Admin
                        </option>
                      </select>
                    </div>
                  </section>
                  <div className='buttonDiv'>
                    <span className='pwdError'>{pwdError ? errorText : ''}</span>
                    <button
                      disabled={
                        userData.email !== '' && userData.user_name !== '' && userData.first_name !== '' && userData.last_name !== '' && userData.password !== '' && userData.role !== 'Select'
                          ? false
                          : true
                      }
                      className={
                        userData.email !== '' && userData.user_name !== '' && userData.first_name !== '' && userData.last_name !== '' && userData.password !== '' && userData.role !== 'Select'
                          ? ''
                          : 'disabled'
                      }
                      onClick={isEditUser ? saveEditUser : createNewUser}>
                      {isEditUser ? 'Save' : 'Create'}
                    </button>
                  </div>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}

      {/* {MsgPopUp && (
        <div className="reasonPopUpContainer">
          <div className="reasonPopUp">
            <h3>Reason For Cancel</h3>
            <textarea  class="form-control" id="inputAddress" placeholder="Enter the message" onInput={(e)=>setRemarkMsg(e.target.value)}></textarea>
            
            <section>
              <button type="button" class="btn btn-primary" onClick={()=>setMsgPopUp(false)}>Exit</button>
              <button type="button" class="btn btn-danger" onClick={confirmDelete}>Proceed</button>
            </section>

          </div>
        </div>
      )} */}
      <ReactTooltip
        id='my-tooltip'
        arrowColor='transparent'
        place='bottom-start'
        delayShow={200}
        style={{
          backgroundColor: '#707070',
          fontSize: '10px',
          textAlign: 'center',
          padding: '5px',
          fontSize: '14',
          fontWeight: 400
        }}
      />
    </div>
  );
}

export default CreateUser;
